if (!customElements.get("m-comparison")) {
  class MComparison extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        compareSelect: "[data-compare-select]",
        itemCount: "[item-count]"
      };

      this._timeout = null;
      this._resizeObserver = null;
      this._mediaHandler = this._handleMediaChange.bind(this);
      this._tabClickHandler = this._handleTabClick.bind(this);
      this._selectChangeHandler = this._handleSelectChange.bind(this);
    }

    connectedCallback() {
      this.setupEventListeners();
      this.setupResizeObserver();
      requestAnimationFrame(() => this.syncHeight());
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      clearTimeout(this._timeout);

      const events = ["matchMobile", "unmatchMobile", "matchTablet", "unmatchTablet"];
      events.forEach(eventName => {
        document.removeEventListener(eventName, this._mediaHandler);
      });

      const tabHeader = document.querySelector('.tab-header[data-block-type="comparison"]');
      if (tabHeader) {
        tabHeader.removeEventListener("click", this._tabClickHandler);
      }

      const select = this.querySelector(this.selectors.compareSelect);
      if (select) {
        select.removeEventListener("change", this._selectChangeHandler);
      }

      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
    }

    setupEventListeners() {
      const select = this.querySelector(this.selectors.compareSelect);
      if (select) {
        select.addEventListener("change", this._selectChangeHandler);
      }

      const tabHeader = document.querySelector('.tab-header[data-block-type="comparison"]');
      if (tabHeader) {
        tabHeader.addEventListener("click", this._tabClickHandler);
      }

      const events = ["matchMobile", "unmatchMobile", "matchTablet", "unmatchTablet"];
      events.forEach(eventName => {
        document.addEventListener(eventName, this._mediaHandler);
      });
    }

    setupResizeObserver() {
      if (typeof ResizeObserver !== "undefined") {
        this._resizeObserver = new ResizeObserver(() => {
          this.debounce(() => this.syncHeight(), 50);
        });
        this._resizeObserver.observe(this);
      }
    }

    _handleSelectChange(event) {
      this.togglePanels(event.target.value);
      this.debounce(() => this.syncHeight(), 100);
    }

    _handleTabClick() {
      this.debounce(() => this.syncHeight(), 100);
    }

    _handleMediaChange() {
      this.debounce(() => this.syncHeight(), 50);
    }

    togglePanels(value) {
      const panels = this.querySelectorAll("[data-comparison-panel]");
      panels.forEach(panel => {
        panel.classList.toggle("hidden", panel.dataset.comparisonPanel !== value);
      });
    }

    debounce(fn, delay) {
      clearTimeout(this._timeout);
      this._timeout = setTimeout(fn, delay);
    }

    syncHeight() {
      const elements = Array.from(this.querySelectorAll("[item-count]"));
      if (!elements.length) return;

      elements.forEach(el => {
        el.style.height = "auto";
      });

      const heightGroups = {};
      elements.forEach(element => {
        const count = element.getAttribute("item-count");
        if (count === null) return;
        if (!heightGroups[count]) {
          heightGroups[count] = [];
        }
        heightGroups[count].push(element);
      });

      requestAnimationFrame(() => {
        Object.values(heightGroups).forEach(group => {
          const visibleHeights = group
            .filter(el => el.offsetParent !== null)
            .map(el => el.offsetHeight);

          if (visibleHeights.length > 0) {
            const maxHeight = Math.max(...visibleHeights);
            if (maxHeight > 0) {
              group.forEach(el => {
                el.style.height = `${maxHeight}px`;
              });
            }
          }
        });
      });
    }

    reinit() {
      this.debounce(() => this.syncHeight(), 50);
    }
  }
  customElements.define("m-comparison", MComparison);
}